import { Menu, MenuItem } from "@mui/material";
import { useRef, useState } from "react";
import { useLanguageSelector } from "~/Header/components/LanguageSelector/LanguageSelector";
import { Chip } from "~/common/m3/Chip/Chip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export const LanguageSelector = () => {
  const { currentLanguage, loading, languages, onItemClick } = useLanguageSelector();
  const [open, setOpen] = useState(false);
  const chipRef = useRef<HTMLDivElement | null>(null);

  if (languages.length <= 1) {
    return null;
  }

  const handleClick = (language: string) => {
    onItemClick(language);
  };

  const toggleMenu = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <Chip
        variant="assist"
        disabled={loading}
        label={currentLanguage.label}
        deleteIcon={<ArrowDropDownIcon sx={{ transform: open ? "rotate(180deg)" : "" }} />}
        onDelete={toggleMenu}
        onClick={toggleMenu}
        ref={chipRef}
      />
      <Menu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={chipRef.current}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {languages.map(({ label, value }) => (
          <MenuItem key={value} onClick={() => handleClick(value)}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
